import { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  useToast,
  FormErrorMessage,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { doc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "config/firebase";
import Sidebar from "components/layouts/Sidebar";
import { useParams } from "react-router-dom";
import useConnect from "./connect";
import { CustomSelectNormal } from "components/CustomSelectNormal";
const EditOperarioSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "El nombre debe tener al menos 2 caracteres")
    .required("El nombre es obligatorio"),
});

const EditVivienda = () => {
  const { clients, normalizeClientsOptions } = useConnect();
  const { id } = useParams();
  const [userData, setUserData] = useState(null);

  const toast = useToast();

  useEffect(() => {
    const fetchUserData = async () => {
      const userDoc = await getDoc(doc(db, "viviendas", id));
      setUserData(userDoc.data());
    };

    fetchUserData();
  }, [id]);

  const formik = useFormik({
    initialValues: userData || {
      name: "",
      clientId: "",
    },
    enableReinitialize: true,
    validationSchema: EditOperarioSchema,
    onSubmit: async (values) => {
      console.log(values);
      try {
        await updateDoc(
          doc(db, "viviendas", id),
          {
            name: values.name,
            clientId: values.clientId,

            updatedAt: serverTimestamp(),
          },
          { merge: true }
        );

        toast({
          title: "Usuario actualizado con éxito",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        // Redirige al usuario al panel de control o a la página de inicio
      } catch (error) {
        toast({
          title: "Error al actualizar al usuario",
          description: error.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    },
  });

  return (
    <Sidebar>
      <Box>
        {userData && (
          <form onSubmit={formik.handleSubmit}>
            <VStack spacing={4}>
              <FormControl
                id="name"
                isInvalid={formik.touched.name && formik.errors.name}
              >
                <FormLabel>Nombre</FormLabel>
                <Input type="text" {...formik.getFieldProps("name")} />
                <FormErrorMessage>{formik.errors.name}</FormErrorMessage>
              </FormControl>
              <FormControl mb={"10px"}>
                <FormLabel>Cliente</FormLabel>
                {clients && (
                  <CustomSelectNormal
                    {...formik.getFieldProps("clientId")}
                    options={normalizeClientsOptions(clients)}
                    defaultValue={formik.values.clientId}
                    onChange={formik.setFieldValue}
                  />
                )}
              </FormControl>
              <Button colorScheme="green" type="submit" w={{ base: "100%" }}>
                Guardar cambios
              </Button>
            </VStack>
          </form>
        )}
      </Box>
    </Sidebar>
  );
};

export default EditVivienda;
